
export const addProductToThanhToan = (product) => {
    return {
        type: "ADD_NEW_PRODUCT",
        product: product
    };
};

export const setAllProductsThanhToan = (products) => {
    return {
        type: "SET_THANHTOAN_PRODUCT",
        products: products
    };
};

export const updateProductThanhToan = (product) => {
    return {
        type: "UPDATE_THANHTOAN_PRODUCT",
        product: product
    };
};

export const getAllProductsThanhToan = () => {
    return {
        type: "GET_ALL_PRODUCTS_THANH_TOAN",
    };
};

export const removeProductFromThanhToan = (index) => {
    return {
        type : "REMOVE_FROM_THANHTOAN_PRODUCT",
        index: index,
    }
}

export const removeAllProductsFromThanhToan = (products) => {
    return {
        type : "REMOVE_ALL_FROM_THANHTOAN_PRODUCT",
        products: products,
    }
}